// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"a0dd13e1","563":"e24c7d46","787":"30fec3a6"}[chunkId] + ".chunk.js";
};